import { render, staticRenderFns } from "./HamburgHowTo.vue?vue&type=template&id=53508400&"
import script from "./HamburgHowTo.vue?vue&type=script&lang=js&"
export * from "./HamburgHowTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports